module.exports = __webpack_public_path__ + "static/media/breath_low.20049a3f.png";